const endpoints = {
  getCode: `auth/get-code`,
  login: `auth`,
  refresh: `auth/refresh`,
  project: {
    list: `eriador/projects`,
  },
  factory: {
    list: (pageNumber: number = 1, projectId: number, searchValue: string = '') =>
      `epics/eriador/factory?project_slug=filimo&page=${pageNumber}&project_id=${projectId}&title=${searchValue}`,
    isQC: `epics/eriador/factory/movie/is-qc`,
    getSubtitle: (movieId: number) => `epics/eriador/factory/movie/subtitles?factory_movie_id=${movieId}`,
  },
  epic: {
    list: (projectId: number) => `epics?project=${projectId}&eriador=1`,
    one: (epicId: number) => `epics/${epicId}`,
    userstories: (epicId: number) => `userstories?epic=${epicId}&include_tasks=true`,
    create: `epics`,
    qcDone: `epics/eriador/factory/movie/qc-done`,
    getMovie: (movieId: number) => `epics/eriador/factory/movie/m3u8?factory_movie_id=${movieId}`,
    getSubtitle: (subId: number) => `https://www.filimo.com/api/fa/v1/movie/subtitle/show/subid/${subId}`,
  },
  userstories: {
    list: (projectId: number) => `userstories?project_id=${projectId}&eriador=1`,
    update: (id: number) => `userstories/${id}`,
    search: (search: string, projectId: number) => `userstories?search=${search}&project_id=${projectId}`,
    activities: (id: number) => `userstories/${id}/activities`,
  },
  task: {
    create: () => `epics/eriador/create-task`,
    delete: (taskId: number) => `tasks/${taskId}`,
    edit: (taskId: number) => `tasks/${taskId}`,
  },
  report: {
    forms: () => `report/forms`,
    submit: (url: string, params: string) => `report/${url}?${params}`,
  },
};

export default endpoints;
